<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Orden de trabajo {{ form.tipo_documento }} {{ numero_documento === ''?'':'-' }} {{ numero_documento }}</h3>
        <label>
          <div v-show="estado === 'A'" class="noti-primary">
            <strong>ABIERTA</strong>
          </div>
          <div v-show="estado === 'V'" class="noti-warning">
            <strong>ASIGNADA</strong>
          </div>
          <div v-show="estado === 'B'" class="noti-info">
            <strong>FACTURABLE</strong>
          </div>
          <div v-show="estado === 'F'" class="noti-success">
            <strong>FACTURADA</strong>
          </div>
          <div v-show="estado === 'C'" class="noti-light">
            <strong>CERRADA</strong>
          </div>
          <div v-show="estado === 'E'" class="noti-danger">
            <strong>ANULADA</strong>
          </div>
          <div v-show="estado === 'N'" class="noti-secondary">
            <strong>NUEVA</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <label for="por_imap">
            <input disabled v-model="por_imap" type="checkbox" name="por_imap" id="por_imap" />
            <span>Via IMAP</span>
          </label>
          <label for="facturable">
            <input
              :disabled="estado !== 'C'"
              @change="changeFacturable"
              v-model="ordenFacturable"
              type="checkbox"
              name="facturable"
              id="facturable"
            />
            <span>Facturable</span>
          </label>
          <button
            v-show="puedeConsultar || puedeAdministrar"
            class="btn-info btn--bigger"
            type="button"
            @click="consultar"
          >
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información del comprobante</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="datepicker-field">
                    <date-picker
                      :disabled="!editable"
                      v-model="form.fecha_emision"
                      type="date"
                      id="fecha_emision"
                    ></date-picker>
                    <label for="fecha_emision">Fecha de emisión *</label>
                    <span
                      v-if="errores.fecha_emision"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.fecha_emision[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div
                  class="form-field select2"
                  :class="{
                                    'select2--disabled' : !editable
                                }"
                >
                  <div class="select2-field">
                    <v-select
                      @input="inputVendedor"
                      label="nombre"
                      :options="vendedores"
                      v-model="selectedVendedor"
                      id="vendedor"
                      placeholder="Seleccione..."
                    ></v-select>
                    <label for="vendedor">Vendedor asignado</label>
                    <span v-if="errores.vendedor_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.vendedor_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="multiselect-field">
                    <multiselect
                      :disabled="!editable"
                      placeholder="Seleccione..."
                      taggable
                      tag-placeholder="Nueva persona"
                      label="nombre"
                      track-by="id"
                      @tag="addPersona"
                      v-model="form.selectedPersona"
                      id="cliente"
                      :options="personas"
                    ></multiselect>
                    <label for="cliente">Persona</label>
                    <span v-if="errores.persona_id" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.persona_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <textarea-field
                    :readonly="!editable"
                    maxlength="1000"
                    v-model="form.comentario"
                    placeholder="Escriba un comentario..."
                    id="comentario"
                  >
                    <span>Comentario</span>
                    <span v-if="errores.comentario" class="helper-text text-danger" slot="helper">
                      <strong>{{ errores.comentario[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="form-field">
                  <textarea-field
                    :readonly="true"
                    maxlength="1000"
                    v-model="observacion"
                    placeholder="..."
                    id="observacion"
                  >
                    <span>Observación</span>
                  </textarea-field>
                </div>
              </div>
              <div v-show="hayProforma" class="col-xs-12 col-md-4">
                <div class="form-field">
                  <div class="form-group">
                    <input-field
                      readonly
                      id="numero_proforma"
                      v-model="form.numero_proforma"
                    >Proforma</input-field>
                    <button @click="verProforma" class="btn-info btn--text">
                      <i class="fa fa-eye"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="form.detalles.length > 0" class="card mt-2">
          <div class="card__title">
            <h5>Detalle de orden de trabajo</h5>
          </div>
          <div class="card__content">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>Item</th>
                    <th>Cantidad</th>
                    <th>Costo</th>
                    <th>Costo total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.detalles" :key="item.id_item_comprobante">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>{{ item.descripcion_item }}</td>
                    <td>
                      <div class="form-field">
                        <input-field
                          :readonly="!editable"
                          :id="'cantidad' + item.id_item_comprobante"
                          vMoney
                          :format="decimal"
                          v-model="item.cantidad"
                          placeholder="##"
                        >
                          <span
                            v-if="errores.hasOwnProperty('detalles.' + index + '.cantidad')"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores['detalles.' + index + '.cantidad'][0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </td>
                    <td>
                      <div class="form-field">
                        <input-field
                          :readonly="!editable"
                          :id="'coste' + item.id_item_comprobante"
                          vMoney
                          :format="money"
                          v-model="item.coste"
                          placeholder="##"
                        >
                          <span
                            v-if="errores.hasOwnProperty('detalles.' + index + '.coste')"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores['detalles.' + index + '.coste'][0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </td>
                    <td>{{ moneyFormat(calcularCostoTotal(index)) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row">Totales</th>
                    <td>
                      <strong>Cantidades totales</strong>
                    </td>
                    <td>{{ decimalFormat(cantidadesTotales) }}</td>
                    <td>
                      <strong>Costos totales</strong>
                    </td>
                    <td>{{ moneyFormat(costosTotales) }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              :disabled="puedeCrear && estado === 'N' && !puedeAdministrar"
              v-show="editable"
              @click="guardar"
              type="button"
              class="btn-success"
            >
              <i class="fa fa-save"></i>
              <span>Guardar</span>
            </button>
            <button
              v-show="puedeAdministrar"
              @click="nueva"
              type="button"
              class="btn-light btn--text"
            >
              <i class="fa fa-plus"></i>
              <span>Nueva</span>
            </button>
            <button v-show="anulable" @click="anular" type="button" class="btn-danger btn--text">
              <i class="fa fa-ban"></i>
              <span>Anular</span>
            </button>
            <button v-show="facturable" @click="facturar" type="button" class="btn-info btn--text">
              <i class="fa fa-file"></i>
              <span>Facturar</span>
            </button>
            <button v-show="cerrable" @click="cerrar" type="button" class="btn-warning btn--text">
              <i class="fa fa-times"></i>
              <span>Cerrar</span>
            </button>
            <button
              v-show="estado !== 'N'"
              @click="$modal.show('auditorias')"
              type="button"
              class="btn-secondary btn--text"
            >
              <i class="fa fa-file-o"></i>
              <span>Logs</span>
            </button>
            <button
              v-show="estado !== 'N'"
              type="button"
              @click="imprimir"
              class="btn-success btn--text"
            >
              <i class="fa fa-print"></i>
              <span>Imprimir</span>
            </button>
            <button class="btn-secondary btn--text" type="button" @click="verAnterior">
              <i class="fa fa-toggle-left"></i>
              <span>Anterior</span>
            </button>
            <button class="btn-secondary btn--text" type="button" @click="verSiguiente">
              <i class="fa fa-toggle-right"></i>
              <span>Siguiente</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal name="listaOrdenesTrabajo" height="auto" width="85%" scrollable>
      <lista-ordenes-trabajo @selected="selectedOrdenTrabajo"></lista-ordenes-trabajo>
    </modal>
    <modal width="50%" name="auditorias" height="auto" scrollable>
      <auditorias ref="auditorias" @cancelar="cancelarAuditorias" :id_comprobante="id"></auditorias>
    </modal>
    <modal name="observacionOT" height="auto" scrollable width="70%">
      <observacion-ot @cancelar="cancelarOt" @cerrada="ordenCerrada" :id="id"></observacion-ot>
    </modal>
  </div>
</template>

<script>
export default {
  computed: {
    editable: function() {
      return this.estado !== "F" && this.estado !== "C";
    },
    cerrable: function() {
      return this.estado === "V";
    },
    facturable: function() {
      return this.estado === "B";
    },
    hayProforma: function() {
      return (
        this.form.numero_proforma != null && this.form.numero_proforma !== ""
      );
    },
    anulable: function() {
      return (
        this.estado !== "E" &&
        this.estado !== "N" &&
        this.editable &&
        this.puedeAdministrar
      );
    },
    cantidadesTotales: function() {
      let cantidadesTotales = 0;
      for (let i = 0; i < this.form.detalles.length; i++) {
        let cantidad = parseFloat(this.form.detalles[i].cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        cantidadesTotales += cantidad;
      }
      return cantidadesTotales;
    },
    costosTotales: function() {
      let costosTotales = 0;
      for (let i = 0; i < this.form.detalles.length; i++) {
        let costo = parseFloat(this.form.detalles[i].costo_total);
        if (isNaN(costo)) costo = 0;
        costosTotales += costo;
      }
      this.form.costo_total = costosTotales;
      return costosTotales;
    }
  },
  props: {
    puedeCrear: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeAdministrar: {
      type: Boolean,
      required: false,
      default: false
    },
    puedeConsultar: {
      type: Boolean,
      required: false,
      default: false
    },
    ordenTrabajoId: {
      required: false,
      default: function() {
        return null;
      }
    },
    vendedores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    personas: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    proforma: {
      type: Object,
      required: false,
      default: function() {
        return null;
      }
    }
  },
  methods: {
    imprimir: function() {
      window.open(url + "/orden-trabajo/" + this.id + "/imprimir", "_blank");
    },
    irADocumento: function(tipoProximidad) {
      let that = this;
      axios
        .get(
          url +
            "/comprobantes/OT/" +
            tipoProximidad +
            (this.id != null && this.id !== "" ? "/" + this.id : "/T")
        )
        .then(function(response) {
          let id = response.data.id;
          if (id === null)
            swal("No hay documento disponible.", "Aviso", "warning");
          else {
            location.href =
              url + "/orden-trabajo/" + response.data.id + "/edit";
          }
        });
    },
    verAnterior: function() {
      this.irADocumento("A");
    },
    verSiguiente: function() {
      this.irADocumento("S");
    },
    changeFacturable: function() {
      if (this.ordenFacturable && this.estado === "C") {
        let that = this;
        swal({
          title: "¿Deseas hacer facturable esta orden de trabajo?",
          text: "Esta acción requiere de confirmación.",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No"
        }).then(function(result) {
          if (result.value) {
            axios
              .post(url + "/orden-trabajo/" + that.id + "/facturable")
              .then(function() {
                that.estado = "B";
                swal(
                  "La orden ha sido asignada como facturable.",
                  "Realizado",
                  "success"
                );
              });
          } else that.ordenFacturable = false;
        });
      }
    },
    cancelarOt: function() {
      this.$modal.hide("observacionOT");
    },
    ordenCerrada: function(observacion, estado) {
      this.observacion = observacion;
      this.estado = estado;
      this.$modal.hide("observacionOT");
    },
    cancelarAuditorias: function() {
      this.$modal.hide("auditorias");
    },
    cerrar: function() {
      this.$modal.show("observacionOT");
    },
    facturar: function() {
      let that = this;
      swal({
        title: "¿Deseas facturar esta orden de trabajo?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Facturar",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          location.href = url + "/facturar-ot/" + that.id;
        }
      });
    },
    verProforma: function() {
      window.open(
        url + "/comprobantes?id_comprobante=" + this.form.proforma_id,
        "_blank"
      );
    },
    selectedOrdenTrabajo: function(ordenTrabajo) {
      let that = this;
      axios
        .get(url + "/orden-trabajo/" + ordenTrabajo.id)
        .then(function(response) {
          that.form.detalles.splice(0, that.form.detalles.length);
          let orden = response.data;
          that.por_imap = ordenTrabajo.por_imap === "S";
          for (let i = 0; i < orden.detalles.length; i++) {
            that.form.detalles.push({
              id_item_comprobante: orden.detalles[i].id_item_comprobante,
              descripcion_item: orden.detalles[i].item.descripcion_item,
              cantidad: orden.detalles[i].cantidad,
              coste: orden.detalles[i].costo,
              costo_total: orden.detalles[i].costo_total,
              id: orden.detalles[i].id
            });
          }
          let personaExistente = false;
          for (let i = 0; i < that.personas.length; i++) {
            if (that.personas[i].id == orden.persona_id) {
              that.form.selectedPersona = that.personas[i];
              personaExistente = true;
              break;
            }
          }
          if (!personaExistente) {
            let persona = {
              id: orden.persona_id,
              nombre: orden.nombre_persona
            };
            that.personas.push(persona);
            that.form.selectedPersona = persona;
          }
          that.ordenFacturable = orden.estado === "B";
          that.observacion = orden.observacion;
          that.form.proforma_id = orden.proforma_id;
          that.form.numero_proforma = orden.numero_proforma;
          that.numero_documento = orden.numero_documento;
          that.form.comentario = orden.comentario;
          for (let i = 0; i < that.vendedores.length; i++)
            if (that.vendedores[i].id == orden.vendedor_id) {
              that.selectedVendedor = that.vendedores[i];
              that.inputVendedor();
              break;
            }
          that.estado = orden.estado;
          that.id = orden.id;
          that.$modal.hide("listaOrdenesTrabajo");
        });
    },
    calcularCostoTotal: function(index) {
      let costoTotal = 0;
      let cantidad = parseFloat(this.form.detalles[index].cantidad);
      if (isNaN(cantidad)) cantidad = 0;
      let costo = parseFloat(this.form.detalles[index].coste);
      if (isNaN(costo)) costo = 0;
      costoTotal = round(cantidad * costo);
      this.form.detalles[index].costo_total = costoTotal;
      return costoTotal;
    },
    addPersona: function(newTag) {
      const tag = {
        nombre: newTag,
        id:
          newTag.substring(0, 2).toUpperCase() +
          Math.floor(Math.random() * 10000000)
      };
      this.personas.push(tag);
      this.form.selectedPersona = tag;
    },
    inputVendedor: function() {
      if (this.selectedVendedor !== null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else this.form.vendedor_id = "";
    },
    consultar: function() {
      this.$modal.show("listaOrdenesTrabajo");
    },
    limpiar: function() {
      this.por_imap = false;
      this.form.tipo_documento = "OT";
      this.form.selectedPersona = null;
      this.selectedVendedor = null;
      this.inputVendedor();
      this.form.fecha_emision = moment(new Date()).format("YYYY-MM-DD");
      this.form.comentario = "";
      this.form.costo_total = 0;
      this.form.proforma_id = "";
      this.form.detalles.splice(0, this.form.detalles.length);
      this.form._method = undefined;
      this.id = "";
      this.form.numero_proforma = "";
      this.numero_documento = "";
      this.estado = "N";
      this.observacion = "";
      this.ordenFacturable = false;
    },
    nueva: function() {
      let that = this;
      swal({
        title: "¿Desea crear un nuevo comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Nuevo comprobante",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          that.limpiar();
        }
      });
    },
    guardar: function() {
      let that = this;
      swal({
        title: "¿Desea guardar el comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Guardar comprobante",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          let urlRequest = url + "/orden-trabajo";
          if (that.id !== "") {
            that.form._method = "PUT";
            urlRequest += "/" + that.id;
          } else that.form._method = undefined;
          axios
            .post(urlRequest, that.form)
            .then(function(response) {
              that.id = response.data.id;
              for (let i = 0; i < that.form.detalles.length; i++)
                that.form.detalles[i].id = response.data.detalles[i].id;
              that.estado = response.data.estado;
              that.ordenFacturable = that.estado === "B";
              that.numero_documento = response.data.numero_documento;
              swal("El comprobante ha sido guardado.", "Anulado", "success");
            })
            .catch(function(error) {
              if (error) {
                let response = error.response;
                if (response) {
                  let status = response.status;
                  if (status === 422) {
                    that.errores = response.data.errors;
                    swal("El formulario posee errores.", "Aviso", "warning");
                    return;
                  }
                }
              }
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    anular: function() {
      let that = this;
      swal({
        title: "¿Desea anular el comprobante?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(url + "/orden-trabajo/" + that.id, {
              _method: "DELETE"
            })
            .then(function() {
              that.estado = "E";
              swal(
                "El comprobante fue anulado con éxito.",
                "Anulado",
                "success"
              );
            })
            .catch(function() {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cargarDatos: function() {
      if (this.proforma !== null) {
        if (this.proforma.orden_trabajo == null) {
          for (let i = 0; i < this.proforma.items.length; i++) {
            this.form.detalles.push({
              id_item_comprobante: this.proforma.items[i].id_item_comprobante,
              descripcion_item: this.proforma.items[i].descripcion_item,
              cantidad: this.proforma.items[i].cantidad,
              coste: this.proforma.items[i].coste,
              costo_total: 0,
              id: ""
            });
          }
          let personaExistente = false;
          for (let i = 0; i < this.personas.length; i++) {
            if (this.personas[i].id == this.proforma.id_persona) {
              this.form.selectedPersona = this.personas[i];
              personaExistente = true;
              break;
            }
          }
          if (!personaExistente) {
            let persona = {
              id: this.proforma.id_persona,
              nombre: this.proforma.nombre_cliente
            };
            this.personas.push(persona);
            this.form.selectedPersona = persona;
          }
          this.form.proforma_id = this.proforma.id_comprobante;
          this.form.numero_proforma = this.proforma.numero_proforma;
        } else
          this.selectedOrdenTrabajo({
            id: this.proforma.orden_trabajo.id
          });
      } else if (this.ordenTrabajoId != null) {
        this.selectedOrdenTrabajo({
          id: this.ordenTrabajoId
        });
      }
    }
  },
  data: function() {
    return {
      por_imap: false,
      ordenFacturable: false,
      decimalFormat: decimalFormat,
      moneyFormat: moneyFormat,
      money: money,
      decimal: decimal,
      estado: "N",
      numero_documento: "",
      id: "",
      comentario: "",
      form: {
        tipo_documento: "OT",
        selectedPersona: null,
        vendedor_id: "",
        fecha_emision: moment(new Date()).format("YYYY-MM-DD"),
        comentario: "",
        costo_total: 0,
        proforma_id: "",
        detalles: [],
        _method: undefined,
        numero_proforma: "",
        facturable: false
      },
      selectedVendedor: null,
      errores: {},
      observacion: ""
    };
  },
  mounted: function() {
    this.cargarDatos();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ordenes-trabajo/OrdenTrabajo.vue